import { ArrowLeft, HelpCircle, Share2, Download } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

export default function EditorHeader() {
  const navigate = useNavigate()

  const handleBack = () => {
    navigate('/')
  }

  return (
    <header className="flex h-16 shrink-0 items-center justify-between px-2">
      <div className="flex items-center gap-4">
        <button
          onClick={handleBack}
          className="rounded-lg p-2 text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-900"
        >
          <ArrowLeft className="h-5 w-5" />
        </button>
        <h1 className="text-lg font-semibold text-gray-900">G8元首的新年七大姑八大姨祝福</h1>
      </div>

      <div className="flex items-center gap-3">
        <button className="p-2 text-gray-400 transition-colors hover:text-gray-600">
          <HelpCircle className="h-5 w-5" />
        </button>
        <button className="flex items-center gap-2 rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm transition-colors hover:bg-blue-700">
          <Share2 className="h-4 w-4" />
          Share
        </button>
        <button className="flex items-center gap-2 rounded-lg bg-gray-900 px-4 py-2 text-sm font-medium text-white shadow-sm transition-colors hover:bg-gray-800">
          <Download className="h-4 w-4" />
          Export
        </button>
      </div>
    </header>
  )
}
